import { render, staticRenderFns } from "./TourInfo.vue?vue&type=template&id=26aff21c&scoped=true&"
import script from "./TourInfo.vue?vue&type=script&lang=js&"
export * from "./TourInfo.vue?vue&type=script&lang=js&"
import style0 from "./TourInfo.vue?vue&type=style&index=0&id=26aff21c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26aff21c",
  null
  
)

export default component.exports